module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      staticClass: "item",
      class: {
        withAvatar: _vm.showAvatar
      }
    }, [(_vm.showAvatar) ? _c('div', {
      staticClass: "img",
      style: ({
        'background-image': ("url(" + (item.photo) + ")")
      })
    }) : _vm._e(), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "author"
    }, [_vm._v(_vm._s(item.fio)), (item.rate) ? _c('raiting-default', {
      staticClass: "stars",
      attrs: {
        "value": typeof item.rate === 'number' ? item.rate : parseInt(item.rate, 10)
      }
    }) : _vm._e(), (!item.rate) ? _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.date))]) : _vm._e()], 1), (item.text && item.rate) ? _c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))]) : (item.text) ? _c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))]) : _vm._e(), (item.to) ? _c('button-default', {
      attrs: {
        "to": item.to,
        "transform": false,
        "fill": false
      }
    }, [_vm._v("Читать далее")]) : _vm._e()], 1)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11714003","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/review/short/Short.vue
// module id = 6ca2eebe2509aa69db72
// module chunks = 0